import { render, staticRenderFns } from "./civilOrder5.vue?vue&type=template&id=ba015286&scoped=true&"
import script from "./civilOrder5.vue?vue&type=script&lang=js&"
export * from "./civilOrder5.vue?vue&type=script&lang=js&"
import style0 from "./civilOrder5.vue?vue&type=style&index=0&id=ba015286&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba015286",
  null
  
)

export default component.exports